import { DocumentTextIcon } from "@heroicons/react/24/outline";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";

import { Label, Small, humanFileSize } from "@fronterahealth/frontera-ui-components";

import { AssessmentToolType } from "@api/graphql/types-and-hooks";

interface DocumentReviewHeaderProps {
  fileName: string;
  fileSize: number;
  skillType: string;
  currentFileIndex: number;
  totalFiles: number;
  onPrevious?: () => void;
  onNext?: () => void;
  supportedAssessments: AssessmentToolType[];
}

export const DocumentReviewHeader: React.FC<DocumentReviewHeaderProps> = ({
  fileName,
  fileSize,
  skillType,
  currentFileIndex,
  totalFiles,
  onPrevious,
  onNext,
  supportedAssessments,
}) => {
  const label = supportedAssessments?.find((assessment) => assessment.id === skillType);
  return (
    <div className="border-b border-t border-limestone-200 bg-white flex items-center justify-between px-6 py-2">
      {/* Left section: File info */}
      <div className="flex items-center gap-2">
        <DocumentTextIcon className="h-4 w-4 text-text-primary shrink-0" />
        <Small className="ph-no-capture">{fileName}</Small>
        <Small>{humanFileSize(fileSize)}</Small>
        {label && (
          <div className="border border-limestone-500 rounded-sm px-1 py-0">
            <Label size="small" displayType="loud" colorType="primary" className="text-limestone-800">
              {label.primary}
            </Label>
          </div>
        )}
      </div>

      {/* Right section: Navigation */}
      <div className="flex items-center gap-4">
        <Small className="whitespace-nowrap">
          {currentFileIndex} of {totalFiles} files
        </Small>
        <div className="flex items-center gap-2">
          <button
            onClick={onPrevious}
            disabled={!onPrevious}
            className="text-text-primary hover:text-text-secondary transition-colors"
            aria-label="Previous file"
          >
            <ChevronLeftIcon className="h-4 w-4" />
          </button>
          <button
            onClick={onNext}
            disabled={!onNext}
            className="text-text-primary hover:text-text-secondary transition-colors"
            aria-label="Next file"
          >
            <ChevronRightIcon className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
